import { render, staticRenderFns } from "./SkeletonServicesTable.vue?vue&type=template&id=0f308002&scoped=true&"
import script from "./SkeletonServicesTable.vue?vue&type=script&lang=js&"
export * from "./SkeletonServicesTable.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonServicesTable.vue?vue&type=style&index=0&id=0f308002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f308002",
  null
  
)

export default component.exports